import _keyBy from 'lodash/keyBy';
import _each from 'lodash/each';

import config from 'src/config';
import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $state, $scope, jsSdkSearch, jsSdkCity, tracking, partnerService, $window) {
  const types = ['VENUE', 'EVENT', 'CURATED_LIST'];

  const cache = {};

  $scope.cities = {};
  $scope.input = '';

  jsSdkCity.list()
    .then(resp => {
      $scope.cities = _keyBy(resp, 'id');
    });

  $scope.clear = function() {
    $scope.fetching = false;
    $scope.input = null;
    $scope.pendingQuery = null;
    $scope.results = null;
    $scope.focus = 0;
  };

  $scope.hover = function(index) {
    $scope.focus = index;
  };

  $scope.select = function(result) {
    goTo(result);
  };

  $scope.search = function(value) {
    if (value.length < 1) {
      $scope.clear();
      return;
    }

    const options = {
      query: value,
      type: types,
      limit: 5
    };

    $scope.lastSearchQuery = value;

    const cacheKey = value.toLowerCase();

    $scope.pendingQuery = cacheKey;

    if (cache[cacheKey]) {
      $scope.results = cache[cacheKey];
      return;
    }

    $scope.fetching = true;

    jsSdkSearch.searchConsumer(options)
      .then(function(resp) {
        const response = _flatten(resp);

        cache[cacheKey] = response;

        if ($scope.pendingQuery === cacheKey) {
          $scope.results = response;
        }

        $scope.fetching = false;
      })
      .catch(function() {
        $scope.fetching = false;
      });
  };

  $scope.keyup = function(event) {
    switch (event.keyCode) {
      case 38:
        $scope.focus -= 1;

        return null;
      case 40:
        $scope.focus += 1;

        return null;
      case 13: //eslint-disable-line
        if (!$scope.results || $scope.results.length < 1) {
          return null;
        }
        const item = $scope.results[$scope.focus];

        if (item) {
          return $scope.select(item);
        }
        break;
      default:
        return null;
    }

    return null;
  };

  $rootScope.$on('$stateChangeStart', function() {
    $scope.clear();
  });

  function _flatten(results) {
    let array = [];

    _each(types, function(type) {
      if (results[type].length <= 0) return;
      array = array.concat(results[type]);
    });

    return array;
  }

  function goTo(item) {
    const trackingData = {};

    trackingData.query = $scope.value;

    if (item.venue) {
      trackingData.type = 'venue';
      trackingData.name = item.name;

      if (config.NODE_ENV === 'production') {
        const fbqData = {
          search_string: $scope.lastSearchQuery,
          content_type: 'product',
          content_ids: [
            item.id
          ],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'Search', fbqData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'Search', fbqData);
      }

      $state.go('app.venue', {
        seoPathname: item.venue.seoPathname || item.id
      });
    }

    if (item.event) {
      trackingData.type = 'event';
      trackingData.name = item.name;

      if (config.NODE_ENV === 'production') {
        const fbqData = {
          search_string: $scope.lastSearchQuery,
          content_type: 'product',
          content_ids: [
            item.event.id
          ],
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          language: navigator.language
        };

        $window.fbq('init', '1606722376242558');
        $window.fbq('trackSingle', '1606722376242558', 'Search', fbqData);
        $window.fbq('init', '316401409092218');
        $window.fbq('trackSingle', '316401409092218', 'Search', fbqData);
      }

      $state.go('app.event', {
        seoPathname: item.event.seoPathname || item.id
      });
    }

    if (item.curatedList) {
      trackingData.type = 'curatedList';
      trackingData.name = item.name;

      $state.go('app.curatedList', {
        id: item.id
      });
    }

    tracking.trackEvent(SEGMENT_EVENTS.SearchResultSelected, trackingData);

    $scope.clear();

    if ($scope.callback) {
      $scope.callback();
    }
  }

  $scope.clear();
}

Ctrl.$inject = [
  '$rootScope',
  '$state',
  '$scope',
  'jsSdk.search',
  'jsSdk.city',
  'trackingService',
  'partnerService',
  '$window'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/search/controller.js